import store from "./store/index";
/**
 * For Translate Datepicker
 * https://www.npmjs.com/package/vuejs-datepicker
 */
import En from 'vuejs-datepicker/dist/locale/translations/en'
import Kh from '@/assets/datepicker/kh'

const __getUserPermission = () => {
    if (store.getters['user/getUserPermissions'] === null) {
        const watcher = store.watch(() => store.getters['user/getUserPermissions'], permissions => {
            watcher(); // stop watching
            let permissionsArray = permissions.map(a => a.name);
            return permissionsArray;
        });
    } else {
        const permissions = store.getters['user/getUserPermissions'];
        let permissionsArray = permissions.map(a => a.name);
        return permissionsArray;
    }
}

const __getUserRoles = () => {
    if (store.getters['user/getUserRoles'] === null) {
        const watcher = store.watch(() => store.getters['user/getUserRoles'], roles => {
            watcher(); // stop watching
            return roles;
        });
    } else {
        return store.getters['user/getUserRoles'];
    }
}

Date.shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default {
    methods: {
        // $hasPermission: permission => {
        //     if (store.getters['user/getUserPermissions'] === null) {
        //         const watcher = store.watch(() => store.getters['user/getUserPermissions'], permissions => {
        //             watcher(); // stop watching
        //             let permissionsArray = permissions.map(a => a.name);
        //             return permissionsArray.includes(permission);
        //         });

        //     } else {
        //         const permissions = store.getters['user/getUserPermissions'];
        //         let permissionsArray = permissions.map(a => a.name);
        //         return permissionsArray.includes(permission);
        //     }
        // },
        $hasPermission: permission => {
            let permissionsArray = __getUserPermission();
            return permissionsArray ? permissionsArray.includes(permission) : false;
        },
        $hasRole: role => {
            let rolesArray = __getUserRoles();
            return rolesArray ? rolesArray.includes(role) : false;
        },
        $hasPermissionOf: permission => {
            let permissionsArray = __getUserPermission();
            let status = false;

            if (typeof permissionsArray != 'object') {
                return status;
            }

            for (let i = 0; i < permissionsArray.length; i++) {
                if (permissionsArray[i].indexOf(permission) > -1) {
                    status = true;
                    break;
                }
            }
            return status;
        },
        $isUrl: (s) => {
            var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
            return regexp.test(s);
        },
        $showImage(src) {
            if(typeof src === 'string'){
                let path = src.split('/');
                path =  path[2] + '/' + path[3];
                window.open(path);
            }else{
                let image = URL.createObjectURL(src)
                window.open(image);
            }
        },

        $formatObjectDate(date, set = false) {
            if(date == 'null' || date == '' || date == null){
                return null;
            }
            var d = new Date(date);
            var day = '' + d.getDate();
            var year = d.getFullYear();
            
            if (day.length < 2)
            day = '0' + day;

            if(set === true){
                var month = Date.shortMonths[d.getMonth()];
                return [day, month, year].join('-');
            }else{
                var month = '' + (d.getMonth() + 1);
                return [day, month, year].join('-');
            }
        },

        $bytesToSize: (bytes) => {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        },
    },
    computed: {
        lang() {
            return (this.$i18n.locale == 'kh') ? Kh : En
        },
        highlightedCurrentDate() {
            return {
                from: Date.now() - 1 * 24 * 60 * 60 * 1000,
                to: Date.now()
            }
        }
    },
};